import React from "react";
import Image from "next/image";
import casino24Logo from "@/app/assets/casino24.png";

const Casino24AdSection = () => {
  return (
    <section className="relative py-14 md:py-20 text-white overflow-hidden bg-gradient-to-b from-slate-950 via-slate-900 to-slate-900">
      <div className="absolute inset-0 z-0 opacity-20">
        <div className="absolute -top-32 -left-24 h-64 w-64 rounded-full bg-cyan-500/30 blur-3xl" />
        <div className="absolute -bottom-40 -right-20 h-72 w-72 rounded-full bg-amber-500/25 blur-3xl" />
      </div>

      <div className="relative max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid gap-8 md:gap-10 lg:gap-14 md:grid-cols-[minmax(0,1.7fr)_minmax(0,1.1fr)] items-center">
          {/* Text / promo content */}
          <div className="order-2 md:order-1 text-center md:text-left space-y-4 md:space-y-5">
            <p className="inline-flex items-center justify-center px-3 py-1 text-[11px] md:text-xs font-semibold uppercase tracking-[0.25em] text-cyan-200/90 bg-white/5 border border-cyan-400/40 rounded-full backdrop-blur-sm mb-2">
              Partner highlight
            </p>
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight">
              Discover top-rated casinos with Casino24
            </h2>
            <p className="text-sm sm:text-base text-gray-200 leading-relaxed max-w-xl mx-auto md:mx-0">
              CasinoB8 helps you understand the landscape; Casino24 handles the
              deep-dive reviews. Compare hand-picked casinos, generous welcome
              packages, and reliable payment options, all from a single, trusted
              source.
            </p>

            <ul className="mt-3 md:mt-4 space-y-2 text-xs sm:text-sm text-gray-200/90">
              <li>
                <span className="font-semibold text-cyan-300">
                  Licensed & vetted:
                </span>{" "}
                Casino24 only lists brands that meet strict standards for
                safety, transparency, and responsible gambling.
              </li>
              <li>
                <span className="font-semibold text-amber-300">
                  Better value:
                </span>{" "}
                compare exclusive bonuses, free spins, and cashback deals before
                you join.
              </li>
              <li>
                <span className="font-semibold text-emerald-300">
                  More ways to play:
                </span>{" "}
                from classic casino games to live tables and sports betting,
                discover platforms that match your style.
              </li>
            </ul>

            <div className="mt-4 flex flex-col sm:flex-row sm:flex-wrap gap-3 justify-center md:justify-start">
              <a
                href="https://www.casino24.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-gradient-to-r from-yellow-400 via-orange-500 to-pink-600 text-black text-sm font-semibold shadow-lg hover:shadow-xl hover:-translate-y-0.5 transition-transform transition-shadow duration-200 focus:outline-none focus:ring-2 focus:ring-yellow-300 focus:ring-offset-2 focus:ring-offset-slate-950"
              >
                Casino24
              </a>
              <a
                href="https://www.casino24.com/casinos"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center px-5 py-2 rounded-full border border-cyan-400/60 text-cyan-100 text-xs sm:text-sm font-medium hover:bg-cyan-500/10 transition-colors"
              >
                Verified Casinos
              </a>
              <a
                href="https://www.casino24.com/sports-betting"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center px-5 py-2 rounded-full border border-emerald-400/60 text-emerald-100 text-xs sm:text-sm font-medium hover:bg-emerald-500/10 transition-colors"
              >
                Sports Betting
              </a>
              <a
                href="https://www.casino24.com/bonuses"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center
                  px-5 py-2 rounded-full border border-yellow-400/60 text-yellow-100 text-xs sm:text-sm font-medium hover:bg-yellow-500/10 transition-colors"
              >
                Bonuses
              </a>
            </div>
          </div>

          {/* Logo / visual side */}
          <div className="order-1 md:order-2 flex justify-center md:justify-end">
            <div className="relative w-full max-w-xs sm:max-w-sm rounded-3xl bg-black/40 border border-white/10 shadow-[0_24px_70px_rgba(0,0,0,0.85)] p-5 sm:p-6 flex flex-col items-center text-center gap-4">
              <div className="relative w-32 h-12 sm:w-40 sm:h-14">
                <Image
                  src={casino24Logo}
                  alt="Casino24 logo"
                  fill
                  sizes="(min-width: 768px) 260px, 180px"
                  className="object-contain drop-shadow-[0_10px_35px_rgba(0,0,0,0.8)]"
                />
              </div>
              <p className="text-xs sm:text-sm text-gray-200 leading-relaxed">
                "Your shortcut to trusted, high-value casino brands. Casino24
                keeps the offers fresh so you can focus on the fun."
              </p>
              <div className="flex flex-wrap justify-center gap-2 text-[10px] sm:text-xs text-gray-300/90">
                <span className="px-3 py-1 rounded-full bg-slate-900/80 border border-cyan-400/40">
                  Verified casinos
                </span>
                <span className="px-3 py-1 rounded-full bg-slate-900/80 border border-amber-300/40">
                  Exclusive bonuses
                </span>
                <span className="px-3 py-1 rounded-full bg-slate-900/80 border border-emerald-300/40">
                  Sports betting
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Casino24AdSection;
